export const validateURL = url => {
  let updatedUrl = url;
  switch (window.location.hostname) {
  case 'dev.oxfordgiftcard.com':
    updatedUrl = `https://oxfordgiftcard.dev.payaccount.io${url}`;
    break;
  case 'staging.oxfordgiftcard.com':
    updatedUrl = `https://oxfordgiftcard.staging.payaccount.io${url}`;
    break;
  case 'oxfordgiftcard.com':
    updatedUrl = `https://oxfordgiftcard.payaccount.io${url}`;
    break;
  default:
    break;
  }

  return updatedUrl;
};

export const validateWhitelabel = (appname) => {
  let updatedAppname = appname;
  switch (window.location.hostname) {
  case 'dev.oxfordgiftcard':
    updatedAppname = 'oxfordgiftcard.dev';
    break;
  case 'staging.oxfordgiftcard':
    updatedAppname = 'oxfordgiftcard.staging';
    break;
  case 'oxfordgiftcard':
    updatedAppname = 'oxfordgiftcard';
    break;
  default:
    break;
  }

  return updatedAppname;
};